import React from 'react';
import { ChevronRight } from 'lucide-react';
import { RADIUS, useTheme } from '../../theme';
import { baseButton } from './shared';

/**
 * Listrad 48 px+: ikon, titel, undertext och något till höger (Switch, Badge, chevron).
 * Med `onClick` blir hela raden en knapp och får chevron om inget annat ligger till höger.
 */
export function ListRow({ icon, title, sub, trailing, onClick, divider, style }: {
  icon?: React.ReactNode; title: React.ReactNode; sub?: React.ReactNode; trailing?: React.ReactNode;
  onClick?: () => void; divider?: boolean; style?: React.CSSProperties;
}) {
  const T = useTheme();
  const body = (
    <>
      {icon && <span aria-hidden style={{ display: 'flex', color: T.textMuted, flexShrink: 0 }}>{icon}</span>}
      <span style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
        <span style={{ display: 'block', fontSize: 15, fontWeight: 600, color: T.text, overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</span>
        {sub && <span style={{ display: 'block', fontSize: 13, fontWeight: 500, color: T.textMuted, marginTop: 2 }}>{sub}</span>}
      </span>
      {trailing ?? (onClick && <ChevronRight size={20} strokeWidth={2} color={T.textMuted} aria-hidden />)}
    </>
  );
  const box: React.CSSProperties = {
    display: 'flex', alignItems: 'center', gap: 12, minHeight: 48, padding: '8px 12px', width: '100%',
    borderBottom: divider ? `1px solid ${T.border}` : undefined, ...style,
  };
  if (!onClick) return <div style={box}>{body}</div>;
  return (
    <button type="button" onClick={onClick}
      style={{ ...baseButton, ...box, justifyContent: 'flex-start', whiteSpace: 'normal', background: 'transparent', borderRadius: divider ? 0 : RADIUS.sm }}>
      {body}
    </button>
  );
}
